export class ExternalUnitSearchRequest {

        constructor(public externalInstId?: string,
                    public externalUnitTitle?: string) {

        }

    }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/ExternalUnitSearchRequest.ts